import { render, staticRenderFns } from "./UpdateClientCredit.vue?vue&type=template&id=5be1bbea&"
import script from "./UpdateClientCredit.vue?vue&type=script&lang=js&"
export * from "./UpdateClientCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports